import { render } from "./AutoReading.vue?vue&type=template&id=545cb7ae&scoped=true"
import script from "./AutoReading.vue?vue&type=script&lang=js"
export * from "./AutoReading.vue?vue&type=script&lang=js"

import "./AutoReading.vue?vue&type=style&index=0&id=545cb7ae&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545cb7ae"]])

export default __exports__